import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher({ className = '' }) {
  const { i18n, t } = useTranslation();

  function setLang(lang) {
    i18n.changeLanguage(lang);
    localStorage.setItem('elvyra_lang', lang);
  }

  return (
    <div className={`lang-switcher ${className}`} style={{ display: 'flex', gap: '8px' }}>
      <button
        onClick={() => setLang('fr')}
        style={{
          padding: '6px 14px',
          borderRadius: '6px',
          border: i18n.language === 'fr' ? '2px solid var(--elvyra-accent)' : '1px solid var(--elvyra-border)',
          background: i18n.language === 'fr' ? 'rgba(0,212,255,0.12)' : 'transparent',
          color: i18n.language === 'fr' ? 'var(--elvyra-accent)' : 'var(--elvyra-text-secondary)',
          cursor: 'pointer',
          fontWeight: i18n.language === 'fr' ? 600 : 400,
          fontSize: '13px',
          transition: 'all 0.2s',
        }}
      >
        🇫🇷 {t('settings.french')}
      </button>
      <button
        onClick={() => setLang('en')}
        style={{
          padding: '6px 14px',
          borderRadius: '6px',
          border: i18n.language === 'en' ? '2px solid var(--elvyra-accent)' : '1px solid var(--elvyra-border)',
          background: i18n.language === 'en' ? 'rgba(0,212,255,0.12)' : 'transparent',
          color: i18n.language === 'en' ? 'var(--elvyra-accent)' : 'var(--elvyra-text-secondary)',
          cursor: 'pointer',
          fontWeight: i18n.language === 'en' ? 600 : 400,
          fontSize: '13px',
          transition: 'all 0.2s',
        }}
      >
        🇬🇧 {t('settings.english')}
      </button>
    </div>
  );
}
